import { mapAgendas } from "../utils"

const dayOne = `09:00 - 10:00	Keynote: Thriving in uncertainty
10:15 - 11:00	B1.5 KPMG: Fast Bytes, Furious Fixes: Conquering OT security challenges in style
11:10 - 11:25	Digital exclusive: Live interview - Attracting and developing talent in Information Security
11:30 - 12:15	B2.3 An OT Sec Programme - Where do I start?
12:20 - 13:20	Congress back in time: Margaret Heffernan - You Have the Attention of the Board. Now What?
13:30 - 14:15 	B3.5 SureCloud: Dynamic information security through a risk management lens
14:30 - 15:15	B4.4 Improving supplier assurance with the Software Bill of Materials: How to get ready for the European Cyber Resilience Act
15:20 - 15:45	ISF Webinar series: The case for social responsibility in AI: Cyber hot seat
15:45 - 16:45 	Keynote: Quantum Computing: The promise and the threat
16:45 - 17:45	ISF Podcast Live! Solving information security problems`

const dayTwo = `09:00 - 10:00	Keynote: The Never Normal
10:15 - 11:00	B5.5 IBM Security: The journey to quantum safe
11:10 - 11:25	Digital exclusive: Live interview - Women in cyber
11:30 - 12:15	B6.3 Future proofing your crypto assets in a post quantum world
12:20 - 13:20	Congress back in time: Sadie Creese - Ransomware: Past, present and future
13:30 - 14:15 	B7.5 SecurityScorecard: Discover the power of cyber risk ratings for legal compliance
14:30 - 15:15	B8.1 The journey from awareness to accountability among all employees
15:20 - 15:45	ISF Webinar series: CISOs, Warfare and Technology in the Spotlight
15:45 - 16:45 	Keynote: The future of information integrity`

const dayThree = `09:00 - 10:00	Keynote: Changing behaviour: Why facts alone don't work
10:15 - 11:00	B9.5 ReversingLabs: Verify trust in commercial software
11:10 - 11:30	ISF Webinar series: Beyond buzz words - AI, ML and the future of Cyber?
11:30 - 12:15	B10.4 How to buy Cyber Insurance in a smart way
12:30 - 13:30	Keynote: Inclusive Leadership`

export default () => {
    const now = new Date(new Date().toLocaleString("en-US", {timeZone: "Europe/London"}))
    const day = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, "0")}-${now.getDate().toString().padStart(2, "0")}`

    const dates = [
        { day: "2023-10-22", sessions: mapAgendas("2023-10-22", dayOne) },
        { day: "2023-10-23", sessions: mapAgendas("2023-10-23", dayTwo) },
        { day: "2023-10-24", sessions: mapAgendas("2023-10-24", dayThree) }
    ]

    return (dates.find(it => it.day === day)?.sessions || dates[0].sessions).map(([start, end, title]) => {
        return 	{
            start,
            end,
            title,
            room: "Auditorium",
            path: "/auditorium",
        }
    })
}